module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "TOC"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "coverpage"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/001coverpage"
    }
  }, [_vm._v("Cover")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/002titlepage"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "dedicationpage"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/003dedicationpage"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "frontmatterpage_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/005frontmatterpage01#frontmatterpage01"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('a', {
    attrs: {
      "href": "#/006part01#part01"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName1"
  }, [_vm._v("The World That Johnson Knew")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter01#chapter01"
    }
  }, [_vm._v("1")]), _vm._v(" What Is Blues?")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter02#chapter02"
    }
  }, [_vm._v("2")]), _vm._v(" Race Records: Blues Queens, Crooners, Street Singers, and Hokum")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter03#chapter03"
    }
  }, [_vm._v("3")]), _vm._v(" What the Records Missed")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter04#chapter04"
    }
  }, [_vm._v("4")]), _vm._v(" Hollers, Moans, and “Deep Blues”")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter05#chapter05"
    }
  }, [_vm._v("5")]), _vm._v(" The Mississippi Delta: Life and Listening")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('a', {
    attrs: {
      "href": "#/012part02#part02"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName1"
  }, [_vm._v("Robert Johnson")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter06#chapter06"
    }
  }, [_vm._v("6")]), _vm._v(" A Life Remembered")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter07#chapter07"
    }
  }, [_vm._v("7")]), _vm._v(" The Music")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter08#chapter08"
    }
  }, [_vm._v("8")]), _vm._v(" First Sessions, Part One: Going For Some Hits")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter09#chapter09"
    }
  }, [_vm._v("9")]), _vm._v(" First Sessions, Part Two: Reaching Back")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/017chapter10#chapter10"
    }
  }, [_vm._v("10")]), _vm._v(" Second Sessions: The Professional")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/018chapter11#chapter11"
    }
  }, [_vm._v("11")]), _vm._v(" The Legacy")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('a', {
    attrs: {
      "href": "#/019part03#part03"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName1"
  }, [_vm._v("The Blues Roll On")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/020chapter12#chapter12"
    }
  }, [_vm._v("12")]), _vm._v(" Jump Shouters, Smooth Trios, and Down-Home Soul")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/021chapter13#chapter13"
    }
  }, [_vm._v("13")]), _vm._v(" The Blues Cult: Primitive Folk Art and the Roots of Rock")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/022chapter14#chapter14"
    }
  }, [_vm._v("14")]), _vm._v(" Farther On Up the Road: Wherefore and Whither the Blues")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "backmatterpage_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/023backmatterpage01#backmatterpage01"
    }
  }, [_vm._v("Afterthought:")]), _vm._v(" So What about the Devil?")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "backmatterpage_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/024backmatterpage02#backmatterpage02"
    }
  }, [_vm._v("Appendix")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "backmatterpage_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/025backmatterpage03#backmatterpage03"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "backmatterpage_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/026backmatterpage04#backmatterpage04"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "index_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/027indexpage#indexpage"
    }
  }, [_vm._v("Searchable Terms")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "acknowledgments_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/028acknowledgmentspage#acknowledgmentspage"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "abouttheauthor_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/029abouttheauthorpage#abouttheauthorpage"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "review_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/030reviewpage#reviewpage"
    }
  }, [_vm._v("Praise")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "copyright_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/031copyrightpage#copyrightpage"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "aboutpublisher_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/032aboutpublisherpage#aboutpublisherpage"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7bcecf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004-TOC.vue
// module id = 66
// module chunks = 0